<template>
  <div class="editable-input" :class="{ 'edit-mode': showInput }">
    <div class="container" :class="{ 'animation fadeIn': showAnimation }">
      <div class="row">
        <div v-if="!showInput" class="col-10">
          <span v-if="value">{{ value }}</span
          ><span class="placeholder" @click="edit" v-else>{{
            placeholder
          }}</span>
        </div>
        <div v-else class="col-10 no-side-padding">
          <input
            v-if="!textarea"
            ref="input"
            @input="onInput"
            type="text"
            :value="otherValue"
            @keyup.enter="saveClicked"
          />
          <textarea
            v-else
            ref="textArea"
            @input="onInput"
            :value="otherValue"
            @keyup.enter="saveClicked"
          />
        </div>
        <div v-if="!showInput" class="col-2 justify">
          <i class="material-symbols-outlined cancel pointer" @click="edit">edit</i>
        </div>
        <div v-else class="col-2 controls">
          <i class="material-symbols-outlined cancel pointer" @click="cancel">close</i>
          <i class="material-symbols-outlined save pointer" @click="saveClicked">done</i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EditableInput',
  props: ['value', 'placeholder', 'textarea'],
  data() {
    return {
      showInput: false,
      otherValue: '',
      showAnimation: false,
    }
  },
  watch: {
    value: {
      handler(val) {
        this.otherValue = val
      },
    },
  },
  methods: {
    cancel() {
      this.showAnimation = true
      this.otherValue = this.value
      this.showInput = false
      this.$emit('cancel')
    },
    edit() {
      this.showAnimation = false
      this.showInput = true
      this.$nextTick(() =>
        this.textarea ? this.$refs.textArea.focus() : this.$refs.input.focus()
      )
    },
    saveClicked(e) {
      this.showAnimation = true
      //emit an event to let parent component know its updated.
      this.$emit('save', this.otherValue)
      this.showInput = false
    },
    onInput(e) {
      this.otherValue = e.target.value
    },
  },
  mounted() {
    this.otherValue = this.value
  },
}
</script>

<style lang='scss' scoped>
.container {
  @include respond-to('sm') {
    padding: 0px;
  }
}
.animation {
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
}
.editable-input {
  padding: 0px;
}
.edit-mode {
  padding: 0px !important;
}
.no-side-padding {
  padding-right: 0;
}
textarea {
  padding: 8px;
  background-color: transparent;
  border: none;
  border-radius: none;
  box-shadow: none;
  width: 90%;
}
input {
  font-size: 1rem;
  padding: 0px;
  background-color: transparent;
  border: none;
  border-radius: none;
  box-shadow: none;
  width: 90%;
}
input:focus {
  border: none;
  box-shadow: none;
  outline: none;
}
.controls {
  display: flex;
  justify-items: center;
  align-items: center;
}
.justify {
  display: flex;
  align-items: center;
  justify-content: center;
}
.cancel {
  color: #757575;
}
.save {
  color: #757575;
}
.placeholder {
  color: #aaa;
  font-style: italic;
  font-size: medium;
}
.col-10 {
  overflow: hidden;
}
</style>